export default __webpack_public_path__ + "static/media/createjs.bdf959be.svg";